<template>
  <div>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Item</th>
          <th>Código</th>
          <th>Base</th>
          <th>Descrição</th>
          <th>Unidade</th>
          <th>Quant. Contrato</th>
          <th>Quantidade Executada</th>
          <th>Acumulado Anterior</th>
          <th>Saldo</th>
          <th v-if="exibirColunaAprovado" class="text-center">Aprovado</th>
        </tr>
      </thead>
      <tbody v-for="item in itens" :key="'item-group-' + item.itemBoletimMedicaoId">
          <tr :class="{ 'item-pai': item.subitens && item.subitens.length > 0 }">
            <td class="coluna-expandir">
              <button
                v-if="item.subitens && item.subitens.length > 0"
                @click="toggleExpand(item.itemBoletimMedicaoId)"
                class="btn-expandir"
              >
                <i v-if="expandidos[item.itemBoletimMedicaoId]" class="fa fa-chevron-down"></i>
                <i v-else class="fa fa-chevron-right"></i>
              </button>
            </td>
            <td>{{ extrairNumeroItem(item.descricao) }}</td>
            <td>{{ item.codigo || '-' }}</td>
            <td>{{ item.base || '-' }}</td>
            <td>
              {{ extrairDescricaoSemNumero(item.descricao) }}
              <button
                class="btn-anexos ml-2"
                @click="toggleAnexos(item.itemBoletimMedicaoId)"
                :title="item.anexos && item.anexos.length > 0 ? 'Ver anexos' : 'Adicionar anexo'"
              >
                <i class="fa fa-paperclip"></i>
                <span class="ml-1">Anexos</span>
                <small v-if="item.anexos && item.anexos.length > 0">({{ item.anexos.length }})</small>
              </button>
            </td>
            <td>{{ item.unidadeMedidaDescricao || '-' }}</td>
            <td>{{ formatarNumero(item.quantidadeContratada) }}</td>
            <td>
              <input
                v-if="modoEdicao && itemEhEditavel(item) && (!item.subitens || item.subitens.length === 0)"
                type="number"
                step="0.01"
                :max="calcularSaldoMaximo(item)"
                v-model.number="item.quantidade"
                @focus="salvarValorOriginal(item)"
                @blur="salvarAlteracao($event, item)"
                :class="['input-edicao', { 'input-invalido': item.quantidade > calcularSaldoMaximo(item) || item.quantidade < -(parseFloat(item.quantidadeAnterior) || 0) }]"
                placeholder="0,00"
              />
              <span v-else>{{ formatarNumero(item.quantidade) }}</span>
            </td>
            <td>{{ formatarNumero(item.quantidadeAnterior) }}</td>
            <td>{{ formatarNumero(calcularSaldo(item)) }}</td>
            <td v-if="exibirColunaAprovado" class="text-center">
              <b-form-checkbox
                v-if="itemPodeSerAprovado(item)"
                :checked="itemAprovado(item.itemBoletimMedicaoId)"
                :disabled="itemJaAprovado(item)"
                @change="atualizarAprovacaoItem(item.itemBoletimMedicaoId, $event)"
              />
            </td>
          </tr>

          <!-- Linha de Anexos do Item Pai -->
          <tr v-if="expandidosAnexos[item.itemBoletimMedicaoId]" :key="'anexo-' + item.itemBoletimMedicaoId">
            <td :colspan="colspanTabela" class="p-0">
              <memoria-calculo-anexos
                :anexos="item.anexos"
                :contratoId="boletimMedicao.contratoId"
                :boletimMedicaoId="boletimMedicao.boletimMedicaoId"
                :itemBoletimMedicaoId="item.itemBoletimMedicaoId"
                :editavel="modoEdicao && itemEhEditavel(item)"
                @anexo-atualizado="$emit('recarregar-dados')"
              ></memoria-calculo-anexos>
            </td>
          </tr>

          <tr v-for="subitem in obterSubitensExpandidos(item)" :key="'sub-' + subitem.itemBoletimMedicaoId" class="subitem">
                <td></td>
                <td>{{ extrairNumeroItem(subitem.descricao) }}</td>
                <td>{{ subitem.codigo || '-' }}</td>
                <td>{{ subitem.base || '-' }}</td>
                <td>
                  {{ extrairDescricaoSemNumero(subitem.descricao) }}
                  <button
                    class="btn-anexos ml-2"
                    @click="toggleAnexos(subitem.itemBoletimMedicaoId)"
                    :title="subitem.anexos && subitem.anexos.length > 0 ? 'Ver anexos' : 'Adicionar anexo'"
                  >
                    <i class="fa fa-paperclip"></i>
                    <span class="ml-1">Anexos</span>
                    <small v-if="subitem.anexos && subitem.anexos.length > 0">({{ subitem.anexos.length }})</small>
                  </button>
                </td>
                <td>{{ subitem.unidadeMedidaDescricao || '-' }}</td>
                <td>{{ formatarNumero(subitem.quantidadeContratada) }}</td>
                <td>
                  <input
                    v-if="modoEdicao && itemEhEditavel(subitem)"
                    type="number"
                    step="0.01"
                    :max="calcularSaldoMaximo(subitem)"
                    v-model.number="subitem.quantidade"
                    @focus="salvarValorOriginal(subitem)"
                    @blur="salvarAlteracao($event, subitem)"
                    :class="['input-edicao', { 'input-invalido': subitem.quantidade > calcularSaldoMaximo(subitem) }]"
                    placeholder="0,00"
                  />
                  <span v-else>{{ formatarNumero(subitem.quantidade) }}</span>
                </td>
                <td>{{ formatarNumero(subitem.quantidadeAnterior) }}</td>
                <td>{{ formatarNumero(calcularSaldo(subitem)) }}</td>
                <td v-if="exibirColunaAprovado" class="text-center">
                  <b-form-checkbox
                    v-if="itemPodeSerAprovado(subitem)"
                    :checked="itemAprovado(subitem.itemBoletimMedicaoId)"
                    @change="atualizarAprovacaoItem(subitem.itemBoletimMedicaoId, $event)"
                  />
                </td>
          </tr>

          <!-- Linha de Anexos do Subitem -->
          <tr v-for="subitem in obterSubitensExpandidos(item)" v-if="expandidosAnexos[subitem.itemBoletimMedicaoId]" :key="'sub-anexo-' + subitem.itemBoletimMedicaoId">
            <td :colspan="colspanTabela" class="p-0">
              <memoria-calculo-anexos
                :anexos="subitem.anexos"
                :contratoId="boletimMedicao.contratoId"
                :boletimMedicaoId="boletimMedicao.boletimMedicaoId"
                :itemBoletimMedicaoId="subitem.itemBoletimMedicaoId"
                :editavel="modoEdicao && itemEhEditavel(subitem)"
                @anexo-atualizado="$emit('recarregar-dados')"
              ></memoria-calculo-anexos>
            </td>
          </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MemoriaCalculoAnexos from './MemoriaCalculoAnexos.vue';
import { statusItemBoletimMedicaoEnum } from '../../../fornecedor/contratos/boletinsMedicoes/BoletimMedicao';

export default {
    name: 'MemoriaCalculoTabela',
    components: {
        MemoriaCalculoAnexos
    },
    props: {
        modoEdicao: {
            type: Boolean,
            default: false
        },
        termoBusca: {
            type: String,
            default: ''
      },
      boletimMedicao: {
        type: Object,
        default: () => {}
      },
      boletimEditavel: {
        type: Boolean,
        default: false
      },
      exibirColunaAprovado: {
        type: Boolean,
        default: false
      },
      itensAprovados: {
        type: Array,
        default: () => []
      },

    },
  data() {
      return {
          expandidos: {},
          expandidosAnexos: {},
          itensModificados: new Set(),
          valoresOriginais: {}
        };
    },
    computed: {
      itens() {
        const ordenarPorNumero = (a, b) =>
          (a.descricao || '').localeCompare(b.descricao || '', undefined, { numeric: true });

        const itens = (this.boletimMedicao?.itens || [])
          .filter(item => item.tipo !== 0)
          .sort(ordenarPorNumero);

        if (!this.termoBusca || this.termoBusca.trim() === '') {
          return itens;
        }

        const termo = this.termoBusca.toLowerCase().trim();
        const itensFiltrados = itens.filter(item => {
          return item.descricao && item.descricao.toLowerCase().includes(termo);
        });

        itensFiltrados.forEach(item => {
          if (item.subitens && item.subitens.length > 0) {
            this.$set(this.expandidos, item.itemBoletimMedicaoId, true);
          }
        });
        return itensFiltrados;
      },
      colspanTabela() {
        return this.exibirColunaAprovado ? 11 : 10;
      }
  },
    methods: {
      extrairNumeroItem(descricao) {
        if (!descricao) return '-';
        const match = descricao.match(/^(\d+(?:\.\d+)*\.?)\s*/);
        return match ? match[1] : '-';
      },

      extrairDescricaoSemNumero(descricao) {
        if (!descricao) return '-';
        return descricao.replace(/^\d+(?:\.\d+)*\.?\s*-?\s*/, '').trim() || descricao;
      },

      toggleExpand(itemId) {
        this.$set(this.expandidos, itemId, !this.expandidos[itemId]);
      },

      toggleAnexos(itemId) {
        this.$set(this.expandidosAnexos, itemId, !this.expandidosAnexos[itemId]);
      },

      obterSubitensExpandidos(item) {
        if (!this.expandidos[item.itemBoletimMedicaoId]) {
          return [];
        }

        return item.subitens || [];
      },

      itemEhEditavel(item) {
        const valorUnitario = parseFloat(item?.valorUnitario);
        const naoAprovado = item?.status !== statusItemBoletimMedicaoEnum.AprovadoFiscalObras;
        return this.boletimEditavel && naoAprovado && !isNaN(valorUnitario) && valorUnitario !== 0;
      },

      itemJaAprovado(item) {
        return item?.status === statusItemBoletimMedicaoEnum.AprovadoFiscalObras;
      },

      itemPodeSerAprovado(item) {
        const valorUnitario = parseFloat(item?.valorUnitario);
        return !isNaN(valorUnitario) && valorUnitario !== 0;
      },

      itemAprovado(itemBoletimMedicaoId) {
        return (this.itensAprovados || []).includes(itemBoletimMedicaoId);
      },

      atualizarAprovacaoItem(itemBoletimMedicaoId, event) {
        const checked = typeof event === 'boolean' ? event : event?.target?.checked;

        if (checked === undefined || checked === null) {
          return;
        }

        const itensAprovadosAtualizados = [...(this.itensAprovados || [])];
        const indiceItem = itensAprovadosAtualizados.indexOf(itemBoletimMedicaoId);

        if (checked && indiceItem === -1) {
          itensAprovadosAtualizados.push(itemBoletimMedicaoId);
        }

        if (!checked && indiceItem !== -1) {
          itensAprovadosAtualizados.splice(indiceItem, 1);
        }

        this.$emit('itens-aprovados-alterados', itensAprovadosAtualizados);
      },

      salvarValorOriginal(item) {
        this.valoresOriginais[item.itemBoletimMedicaoId] = item.quantidade || 0;
      },

      calcularSaldoMaximo(item) {
        const quantidadeContratada = parseFloat(item.quantidadeContratada) || 0;
        const quantidadeAcumulada = parseFloat(item.quantidadeAnterior) || 0;
        return quantidadeContratada - quantidadeAcumulada;
      },

      calcularSaldo(item) {
        const quantidadeContratada = parseFloat(item.quantidadeContratada) || 0;
        const quantidadeAcumulada = parseFloat(item.quantidadeAnterior) || 0;
        const quantidade = parseFloat(item.quantidade) || 0;

        return quantidadeContratada - (quantidadeAcumulada + quantidade);
      },

      formatarNumero(valor) {
        if (valor === null || valor === undefined || valor === '') return '-';
        const numero = parseFloat(valor);
        if (isNaN(numero)) return '-';
        return numero.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },

      salvarAlteracao(event, item) {
        const valor = event.target.value;
        const valorOriginal = this.valoresOriginais[item.itemBoletimMedicaoId] || 0;

        if (valor === null || valor === undefined || valor === '' || isNaN(parseFloat(valor))) {
          item.quantidade = valorOriginal;
          this.itensModificados.delete(item.itemBoletimMedicaoId);

          if (this.$toast) {
            this.$toast.error('A quantidade informada não é válida. Por favor, insira um número positivo, negativo ou zero, podendo conter casas decimais.', 'Validação', {
              position: 'topRight',
              timeout: 5000
            });
          }

          this.$nextTick(() => {
            event.target.focus();
            event.target.select();
          });

          return;
        }

        const quantidadeInformada = parseFloat(valor);
        const quantidadeContratada = parseFloat(item.quantidadeContratada) || 0;
        const quantidadeAcumulada = parseFloat(item.quantidadeAnterior) || 0;
        const saldoDisponivel = quantidadeContratada - quantidadeAcumulada;
        const minimoPermitido = -quantidadeAcumulada;

        if (quantidadeInformada < minimoPermitido || quantidadeInformada > saldoDisponivel) {
          item.quantidade = valorOriginal;
          this.itensModificados.delete(item.itemBoletimMedicaoId);

          const mensagem = quantidadeInformada < minimoPermitido
            ? `A quantidade informada (${quantidadeInformada.toFixed(2)}) devolve mais do que o acumulado anterior (${quantidadeAcumulada.toFixed(2)}). O mínimo permitido é ${minimoPermitido.toFixed(2)}.`
            : `A quantidade informada (${quantidadeInformada.toFixed(2)}) ultrapassa o saldo disponível (${saldoDisponivel.toFixed(2)}).`;

          if (this.$toast) {
            this.$toast.error(mensagem, 'Erro de Validação', {
              position: 'topRight',
              timeout: 7000
            });
          }

          this.$nextTick(() => {
            event.target.focus();
            event.target.select();
          });

          return;
        }

        this.itensModificados.add(item.itemBoletimMedicaoId);

        this.$emit('itens-alterados');
      },

      getItensModificados() {
        const itens = this.boletimMedicao?.itens || [];
        const modificados = [];

        itens.forEach(item => {
          if (this.itensModificados.has(item.itemBoletimMedicaoId)) {
            modificados.push(item);
          }

          if (item.subitens && item.subitens.length > 0) {
            item.subitens.forEach(subitem => {
              if (this.itensModificados.has(subitem.itemBoletimMedicaoId)) {
                modificados.push(subitem);
              }
            });
          }
        });

        return modificados;
      },

      limparItensModificados() {
        this.itensModificados.clear();
      },

      validarAntesDeSalvar() {
        const itens = this.itens;
        const erros = [];

        itens.forEach(item => {
          const quantidade = parseFloat(item.quantidade) || 0;
          const quantidadeContratada = parseFloat(item.quantidadeContratada) || 0;
          const quantidadeAcumulada = parseFloat(item.quantidadeAnterior) || 0;
          const saldoDisponivel = quantidadeContratada - quantidadeAcumulada;

          const minimoPermitido = -quantidadeAcumulada;
          if (quantidade < minimoPermitido || quantidade > saldoDisponivel) {
            erros.push({
              item: this.extrairNumeroItem(item.descricao),
              descricao: this.extrairDescricaoSemNumero(item.descricao),
              quantidadeInformada: quantidade,
              saldoDisponivel: saldoDisponivel,
              minimoPermitido: minimoPermitido
            });
          }

          if (item.subitens && item.subitens.length > 0) {
            item.subitens.forEach(subitem => {
              const subQuantidade = parseFloat(subitem.quantidade) || 0;
              const subQuantidadeContratada = parseFloat(subitem.quantidadeContratada) || 0;
              const subQuantidadeAcumulada = parseFloat(subitem.quantidadeAnterior) || 0;
              const subSaldoDisponivel = subQuantidadeContratada - subQuantidadeAcumulada;
              const subMinimoPermitido = -subQuantidadeAcumulada;

              if (subQuantidade < subMinimoPermitido || subQuantidade > subSaldoDisponivel) {
                erros.push({
                  item: this.extrairNumeroItem(subitem.descricao),
                  descricao: this.extrairDescricaoSemNumero(subitem.descricao),
                  quantidadeInformada: subQuantidade,
                  saldoDisponivel: subSaldoDisponivel,
                  minimoPermitido: subMinimoPermitido
                });
              }
            });
          }
        });

        if (erros.length > 0) {
          const mensagensErro = erros.map(erro =>
            `Item ${erro.item}: ${erro.descricao.substring(0, 50)}... - Quantidade informada (${erro.quantidadeInformada.toFixed(2)}) ultrapassa o saldo disponível (${erro.saldoDisponivel.toFixed(2)})`
          ).join('<br><br>');

          if (this.$toast) {
            this.$toast.error(
              `Não é possível salvar. Os seguintes itens possuem quantidade executada maior que o saldo disponível:<br><br>${mensagensErro}`,
              'Erro de Validação',
              {
                position: 'topRight',
                timeout: 10000
              }
            );
          }

          return false;
        }

        return true;
      }
    }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
}

th, td {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 12px 8px;
  text-align: left;
}

th {
  background-color: transparent;
  font-weight: 600;
  color: #333;
}

.coluna-expandir {
  width: 40px;
  text-align: center;
}

.btn-expandir {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 12px;
  color: #2E60AD;
  outline: none !important;
  box-shadow: none !important;
}

.btn-expandir:focus,
.btn-expandir:active,
.btn-link,
.btn-link:focus,
.btn-link:active,
.btn-link:hover,
button:focus,
button:active {
  outline: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  text-decoration: none !important;
  border: none !important;
}

.btn-expandir:hover {
  color: #2E60AD;
}

.item-pai {
  background-color: #DDDDDD;
}

.item-pai:hover {
  background-color: #DDDDDD;
}

.subitem {
  background-color: #fff;
}

.subitem:hover {
  background-color: #f5f5f5;
}

.input-edicao {
  width: 80px;
  padding: 4px 8px;
  border: 1px solid #CCC;
  border-radius: 4px;
  font-size: 13px;
  outline: none;
  text-align: left;
}

.input-edicao:focus {
  border-color: #2E60AD;
  box-shadow: 0 0 0 1px rgba(46, 96, 173, 0.2);
}

.input-invalido {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 1px rgba(220, 53, 69, 0.2) !important;
}

.input-edicao::-webkit-outer-spin-button,
.input-edicao::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input-edicao[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}

.btn-anexos {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 8px;
  border: 1px solid #2E60AD;
  border-radius: 4px;
  background-color: #2E60AD;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
}

.btn-anexos:hover {
  filter: brightness(0.9);
}

.btn-anexos:focus,
.btn-anexos:active {
  border: 1px solid #2E60AD !important;
  background-color: #2E60AD !important;
}

.btn-anexos i,
.btn-anexos span,
.btn-anexos small {
  color: #fff;
}
</style>
